import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box, InputBase, FormControl, IconButton, Grid, List,
    Button, Dialog, DialogContent, DialogActions, Typography,
    Divider, RadioGroup, Radio, FormControlLabel, CircularProgress, Collapse
} from '@material-ui/core';
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import { Close } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomMessagePoper from './custom-message-popover';
import { useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import Checkbox from '../checkbox';
import Field from '../users/CustomTextField';
import CustomTextField from '../CustomizedUIs/CustomTextFieldWithFontSize';
import { listChange } from '../message/actions';
import { useDispatch } from 'react-redux';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import {
    RECEIVER_TYPE, MESSAGES_TYPE, DEFAULT_ALARM_TEMPLATE, SCHEDULE_TYPE, EXPIRATION_TYPE,
    getListIdsSaveAsDraft, trimSubjectStr, getTemplateInterval, FONT_SIZE_LABEL
} from '../utils';
import DateTimePicker from '../common/date-time-picker';
import SelectBoxTemplateList from '../common/select-template-list';
import SelectBoxTone from '../common/selectbox-tone';
import SelectBoxScheduleTemplate from '../common/select-box-schedule-template';
import icSearch from '../assets/icons/grayscale-3-search.png'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import SelectBoxInterval from '../common/select-box-interval';
import TransferList from '../message/TransferList';
import { cloneDeep } from 'lodash';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles((theme) => ({
    list: {
        height: 255,
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '2.8px !important',
            height: "5px",
            borderRadius: "4px",
            backgroundColor: ' #c1e5fa'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 10px white',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1e5fa',
            borderRadius: '10px'
        }
    },
    dialogCloseBtn: {
        marginLeft: 7,
        width: "25px",
        height: "25px",
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        maxWidth: '650px',
        backgroundColor: theme.palette.background.default
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    inputMulti: {
        width: '525px',
        borderRadius: '2px',
    },
    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '16px',
        top: '20px'
    },
    addRecipientsText: {
        paddingBottom: '2px',
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: " #4f5064",
    },
    switchAddAll: {
        width: 140,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginLeft: '24px'
    },
    saveDraft: {
        width: ' 111px',
        height: '36px',
        borderRadius: '10px',
        border: ' solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
    },
    send: {
        marginRight: '30px',
        height: '36px',
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
    },
    divider: {
        marginTop: '14px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: " 0.36px",
        color: "#4f5064",
    },
    borderSearch: {
        borderRadius: "8.1px",
        border: "solid 0.8px #f1f2f4",
        backgroundColor: "#f7f7f7",
    },
    textSearch: {
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
    iconSearch: {
        border: "solid 0px #b4b5bd",
    },
    clusterText: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 2.18,
        letterSpacing: "0.11px",
        color: "#4f5064",
    },
    btnClose: {
        fontFamily: " UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "0.4px",
        color: "#4f5064",
    },
    Title: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        paddingBottom: "30px",
        marginTop: -10
    },
    textSelectBox: {
        width: '244px',
        height: '24px',
        fontFamily: 'UniviaPro-Medium',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: ' 0.13px',
        color: '#88898c',
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
    },
    TextDateTime: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.85,
        letterSpacing: " 0.13px",
        color: "#4f5064",
    },
    titleDateTime: {
        fontFamily: " UniviaPro",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.36,
        letterSpacing: "normal",
        color: "#88898c",
    },
    TitileDyslexieFont: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.22,
        letterSpacing: " 0.36px",
        color: "4f5064",
    },
   
    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: theme.palette.primary.main,
    },
    btnSend: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: '#ffffff',
    },
    NoRecipientsSelected: {
        paddingBottom: '2px',
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#88898c",
    },
}));

let dialogContent;
const DialogAlarmSendMessage = ({ loadingDialog, open, onClose, receiver, data, repSubject, isInCluster }) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const list = useSelector((state) => state.list);
    const dispatch = useDispatch();

    // STATE
    const [template, setTemplate] = useState("");
    const [templateID, setTemplateID] = useState(null);
    const [selectedTone, setSelectedTone] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDraft, setLoadingDraft] = useState(false);
    const [filter, setFilter] = useState("");
    const [checkedSwitch, setCheckedSwitch] = useState(false);
    const [start, setStart] = useState(true);
    const [left, setLeft] = useState([]);
    const [cloneLeft, setCloneLeft] = useState([]);
    const [leftFilter, setLeftFilter] = useState([]);
    const [right, setRight] = useState([]);
    const [individuals, setIndividuals] = useState([]);
    const [cloneIndividuals, setCloneIndividuals] = useState([]);
    const [openTemplate, setOpenTemplate] = useState(false);
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [valueScheduleRadio, setValueScheduleRadio] = useState(0);
    const [valueExpirationRadio, setValueExpirationRadio] = useState(0);
    const [dateSchedule, setDateSchedule] = useState(new Date());
    const [dateExpiration, setDateExpiration] = useState(new Date());
    const [fontSize, setFontSize] = useState(FONT_SIZE_LABEL.MEDIUM);
    const [listTemplates, setListTemplates] = useState([]);
    const [isDyslexieEnable, setDyslexieEnable] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [selectedScheduleTemplate, setSelectedScheduleTemplate] = useState(null);
    const [selectedRecurrence, setSelectedRecurrence] = useState(null);
    const [listScheduleTemplate, setListScheduleTemplate] = useState([]);
    const [error, setError] = useState({
        isError: true,
        message: ""
    });
    const [textValue, setTextValue] = useState({
        subject: '',
        content: '',
    });

    const onChangeFilter = (event) => {
        setFilter(event.target.value)
        searchRecipient(event.target.value)
    }

    const searchRecipient = (value) => {
        if (receiver === 'Individuals') {
            setLeft(leftFilter.reduce((arr, currentItem) => {
                if (currentItem.name.includes(value)) {
                    arr.push(currentItem)
                }
                else {
                    const items = currentItem.rooms.filter(item => item.number === parseInt(value) || item.name.toLowerCase().includes(value.toLowerCase()));
                    if (items.length > 0)
                        arr.push({ name: currentItem.name, rooms: items });
                }
                return arr
            }, []))
            if (isInCluster === false) {
                if (right.length > 0 && value === '') {
                    for (let i = 0; i < right.length; i++) {
                        for (let j = 0; j < right[i].rooms.length; j++) {
                            leftFilter.map(item => {
                                item.rooms.map((room, index) => {
                                    right[i].rooms.map(rm => {
                                        if (rm.uniqueRoomName === room.uniqueRoomName) {
                                            item.rooms.splice(index, 1)
                                        }
                                    })
                                })
                            })
                        }
                    }
                    leftFilter.map((item, index) => {
                        if (item.rooms.length === 0)
                            leftFilter.splice(index, 1)
                    })
                    setLeft(leftFilter)
                }
            }
            else {
                if (right.length > 0 && value === '') {
                    for (let j = 0; j < right[0].rooms.length; j++) {
                        leftFilter.map(item => {
                            item.rooms.map((room, index) => {
                                right[0].rooms.map(rm => {
                                    if (rm.number === room.number) {
                                        item.rooms.splice(index, 1)
                                    }
                                })
                            })
                        })
                    }
                    leftFilter.map((item, index) => {
                        if (item.rooms.length === 0)
                            leftFilter.splice(index, 1)
                    })
                    setLeft(leftFilter)
                }
            }
        }
        else {
            setLeft(leftFilter.filter(item => {
                if (item.name.toUpperCase().includes(value.toUpperCase())) {
                    return item
                }
                else {
                    return null
                }
            }))
            if (right.length > 0 && value === '') {
                if (receiver !== RECEIVER_TYPE.CLUSTER) {
                    right.map(itemRight => {
                        leftFilter.map((itemLeft, index) => {
                            if (itemLeft.name === itemRight.name) {
                                leftFilter.splice(index, 1)
                            }
                        })
                    })
                    setLeft(leftFilter)
                }
                else {
                    right.map(itemRight => {
                        leftFilter.map((itemLeft, index) => {
                            if (itemLeft.uniqueName === itemRight.uniqueName) {
                                leftFilter.splice(index, 1)
                            }
                        })
                    })
                    setLeft(leftFilter)
                }
            }
        }
    }

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'content') {
            if (value.length === 0) {
                setError(
                    value.length === 0 ? {
                        isError: true, message: translate('pos.messages.required')
                    } : {
                            isError: false, message: ''
                        }
                )
            }
            else {
                setError(
                    {
                        isError: false,
                        message: ''
                    }
                )
            }
        }
    }

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const getListIndividual = () => {
        setLoading(true)
        dataProvider('GET_LIST', "room/assign", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        })
            .then(({ data }) => {
                // data.listUser.map(user => {
                //     user.idx = user.id
                //     user.name = `${user.username} - ${user.firstName} ${user.lastName}`
                // })
                data.listRoom.map(room => {
                    room.name += ` - ID: ${room.number}`
                    room.cluster.uniqueName = `${room.cluster.name}-${room.cluster.entity}-${room.cluster.group}`
                })

                var group = data.listRoom.reduce((r, a) => {
                    r[a.cluster.uniqueName] = [...r[a.cluster.uniqueName] || [], a];
                    return r;
                }, {});

                var clusterName = []
                data.listRoom.map(item => {
                    clusterName.push(item.cluster)
                })

                var temp = []
                clusterName.map(cluster => {
                    temp.push(group[cluster.uniqueName])
                })
                var unique = temp.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                })
                var listRoom = []
                unique.forEach(item => {
                    item.map(elem => {
                        elem.uniqueRoomName = `${elem.name} - ${elem.cluster.name}-${elem.cluster.entity}-${elem.cluster.group}`
                    })
                    var array = {
                        name: item[0].cluster.name,
                        rooms: item
                    }
                    listRoom.push(array)
                })
                setIndividuals(listRoom)
                const cloneListRoom = cloneDeep(listRoom)
                setCloneIndividuals(cloneListRoom)
                setLoading(false)
            })
            .catch(error => {
                // TODO: Should show error message
                setLoading(false)
            })
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleToggleAll = (items) => () => {
        if (receiver === 'Individuals') {
            var tempData = cloneIndividuals
            if (checkedSwitch === false) {
                setCheckedSwitch(true);
                setLeft([])
                setLeftFilter([]);
                setRight(tempData)
            }
            else {
                setCheckedSwitch(false);
                setLeft(tempData)
                setLeftFilter(tempData)
                setRight([])
                setFilter('')
            }
        }
        else {
            setCheckedSwitch(!checkedSwitch);
            setStart(false)
        }
    };

    const handleRadioScheduleChange = (event) => {
        setValueScheduleRadio(parseInt(event.target.value));
    };

    const handleRadioExpirationChange = (event) => {
        setValueExpirationRadio(parseInt(event.target.value));
    };

    const clearDialog = () => {
        setLeft([]);
        setLeftFilter([]);
        setRight([]);
        setIndividuals([]);
        setFilter("");
        setCheckedSwitch(false);
        setOpenPopper(false);
        setTemplate("");
        setOpenTemplate(false);
        setValueScheduleRadio(0);
        setValueExpirationRadio(0);
        setTextValue({
            subject: '',
            content: '',
        });
        setDateSchedule(new Date())
        setDateExpiration(new Date())
        setDyslexieEnable(false)
        setError({
            isError: false,
            message: ""
        });
        setSelectedScheduleTemplate(null);
        setSelectedRecurrence(null);
        setFontSize(FONT_SIZE_LABEL.MEDIUM);
    }

    const handleClose = () => {
        clearDialog()
        onClose();
    }

    const onChangeRecurrence = (value) => {
        if (value.name === 'None')
            setSelectedRecurrence(null)
        else
            setSelectedRecurrence(value)
    }
    const onChangeScheduleTemplate = (value) => {
        setSelectedScheduleTemplate(value);
        if (value.scheduleMessages.length > 0) {
            const firstTemplate = value.scheduleMessages[0];
            setTextValue({
                subject: firstTemplate.subject,
                content: firstTemplate.message,
            });
        }
    }

    const autoHideErrorMessage = () => {
        setTimeout(() => {
            setErrorMsg('');
        }, 6000);
    }

    const getBodyToSendImmediately = () => {
        const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;
        return {
            subject: trimSubjectStr(textValue.subject, textValue.content, false),
            message: textValue.content,
            toneUrl: selectedTone ? selectedTone.fd : '',
            fontSize: fontSize,
            scheduleType: valueScheduleRadio,
            expiration: expiration,
            dyslexie: isDyslexieEnable,
            receiverType: receiver,
            ids: getListIdsSaveAsDraft(receiver, right),
        };
    }

    const sendImmediately = () => {
        setLoading(true);
        const data = getBodyToSendImmediately();
        dataProvider('CREATE', 'alarm', { data }).then(() => {
            onClose(MESSAGES_TYPE.SENT);
            clearDialog();
            setLoading(false)
        }).catch(error => {
            setLoading(false);
            console.error('CREATE MESSAGE SCHEDULE:', error);
        });
    }

    const sendSchedule = () => {
        if (valueScheduleRadio === 1 && new Date(dateSchedule) < Date.now()) {
            setErrorMsg(translate(`pos.common.scheduleExpired`))
            dialogContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            autoHideErrorMessage();
        }
        else if (valueExpirationRadio !== 0 && new Date(dateExpiration) < new Date(dateSchedule)) {
            setErrorMsg(translate(`pos.messages.errorExpiration`));
            dialogContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
            autoHideErrorMessage();
        }
        else {
            if (valueExpirationRadio !== 0 && new Date(dateExpiration) < Date.now()) {
                setErrorMsg(translate(`pos.messages.errorExpiration`));
                dialogContent.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
                autoHideErrorMessage();
            }
            else {
                const schedule = valueScheduleRadio === 1 ? dateSchedule.getTime() : -1;
                const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;

                const data = {
                    ids: JSON.stringify(getListIdsSaveAsDraft(receiver, right)),
                    subject: trimSubjectStr(textValue.subject, textValue.content, false),
                    message: textValue.content,
                    toneUrl: selectedTone ? selectedTone.fd : '',
                    fontSize: fontSize,
                    receiverType: receiver,
                    schedule: schedule,
                    scheduleType: valueScheduleRadio,
                    interval: valueScheduleRadio === 1 ? (selectedRecurrence ? selectedRecurrence.value : 'none') : 'none',
                    expiration: expiration,
                    dyslexie: isDyslexieEnable
                };

                setLoading(true);
                dataProvider('CREATE', 'alarm/schedule', { data }).then(() => {
                    onClose(MESSAGES_TYPE.SCHEDULED);
                    clearDialog();
                    setLoading(false);
                }).catch(error => {
                    setLoading(false);
                    console.error('CREATE ALARM SCHEDULE:', error);
                });
            }
        }
    }

    const sendScheduleTemplate = () => {
        const expiration = valueExpirationRadio === 1 ? dateExpiration.getTime() : 0;
        const data = {
            subject: textValue.subject,
            message: textValue.content,
            toneUrl: selectedTone ? selectedTone.fd : '',
            fontSize: fontSize,
            receiverType: receiver,
            expiration: expiration,
            scheduleTemplateId: selectedScheduleTemplate.id,
            dyslexie: isDyslexieEnable,
            ids: getListIdsSaveAsDraft(receiver, right),
        };

        setLoading(true);
        dataProvider('CREATE', 'alarm/create-list-schedule', {
            data
        }).then(res => {
            setLoading(false);
            clearDialog();
            onClose(MESSAGES_TYPE.SCHEDULED);
        }).catch(error => {
            console.error('CREATE LIST SCHEDULE ALARM ERROR:', error);
        });
    }

    const handleSendAlarm = () => {
        switch (valueScheduleRadio) {
            case SCHEDULE_TYPE.IMMEDIATELY:
                sendImmediately();
                break;
            case SCHEDULE_TYPE.OTHER:
                sendSchedule();
                break;
            case SCHEDULE_TYPE.SCHEDULE_TEMPLATE:
                sendScheduleTemplate();
                break;
            default:
                break;
        }
    }

    const handleSaveDraftAlarm = () => {
        setLoadingDraft(true)
        const expiration = valueExpirationRadio === EXPIRATION_TYPE.DAY_TIME ? dateExpiration.getTime() : 0;
        const data = {
            ids: JSON.stringify(getListIdsSaveAsDraft(receiver, right)),
            subject: textValue.subject,
            message: textValue.content,
            template: templateID,
            toneUrl: selectedTone ? selectedTone.fd : '',
            fontSize: fontSize,
            scheduleType: valueScheduleRadio,
            interval: valueScheduleRadio === 1 ? (selectedRecurrence ? selectedRecurrence.value : 'none') : 'none',
            receiverType: receiver,
            expiration: expiration,
            dyslexie: isDyslexieEnable,
        };
        switch (valueScheduleRadio) {
            case SCHEDULE_TYPE.IMMEDIATELY:
                data.schedule = 0;
                data.scheduleTemplate = null;
                break;
            case SCHEDULE_TYPE.OTHER:
                data.schedule = dateSchedule.getTime();
                data.scheduleTemplate = null;
                break;
            case SCHEDULE_TYPE.SCHEDULE_TEMPLATE:
                data.schedule = 0;
                data.scheduleTemplate = selectedScheduleTemplate.id;
                break;
        }
        dataProvider('CREATE', 'alarm/draft', { data }).then(() => {
            onClose(MESSAGES_TYPE.DRAFT)
            clearDialog()
            setLoadingDraft(false)
        }).catch((error) => {
            console.error('CREATE DRAFT ALARM ERROR:', error);
            setLoadingDraft(false)
        });
    }

    const getListScheduleTemplates = () => {
        setLoading(true)
        dataProvider('GET_LIST', "schedule-template", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },
        }).then(({ data }) => {
            setListScheduleTemplate(data)
            setLoading(false)
        }).catch(error => {
            console.error('getListScheduleTemplates:', error);
            setLoading(false)
        });
    }

    const onChangeTemplate = (item) => {
        if (item.name !== "None") {
            setTemplate(item.name);
            setTemplateID(item.id);
            setFontSize(item.fontSize);
        }
        else {
            setTemplate("");
            setTemplateID(null);
            setFontSize(FONT_SIZE_LABEL.MEDIUM)
        }
        setTextValue({
            subject: item.subject,
            content: item.message,
        });
        setError({
            isError: false,
            message: ""
        });
        setValueScheduleRadio(item.scheduleType);
        if (item.scheduleType === 1) {
            setDateSchedule(new Date(item.schedule));
        }
        if (item.scheduleType === 2) {
            listScheduleTemplate.map(value => {
                if (value.id === item.scheduleTemplate)
                    setSelectedScheduleTemplate(value)
            })
        }

        if (item.expiration > 0) {
            setValueExpirationRadio(1);
            setDateExpiration(new Date(item.expiration));
        } else {
            setValueExpirationRadio(0);
        }
        setDyslexieEnable(item.dyslexie);
        setOpenTemplate(false);
        setSelectedRecurrence(getTemplateInterval(item.interval))
        if (item.tone && item.tone.name !== "None")
            setSelectedTone(item.tone);
        else
            setSelectedTone("");
    }

    const handleClickOpenTemplate = () => {
        setOpenTemplate(!openTemplate)
    }

    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    const getListTemplates = () => {
        dataProvider('GET_LIST', "alarm-templates", {
            filter: {},
            pagination: { page: 1, perPage: 100 },
            sort: { field: 'createdAt', order: 'DESC' },
        }).then(({ data }) => {
            data.unshift(DEFAULT_ALARM_TEMPLATE);
            setListTemplates(data);
        }).catch(error => {
            // TODO: Should show error message
            console.error('getTemplates error:', error)
        })
    }

    const disableSendButton = () => {
        if (textValue.content === '' || right.length === 0 || !selectedTone) return true;
        if (valueScheduleRadio === 2 && !selectedScheduleTemplate) return true;
        return false;

        // return textValue.subject && textValue.content && selectedTone && right.length > 0;
    }

    useEffect(() => {
        getListTemplates();
        getListScheduleTemplates();
    }, []);

    useEffect(() => {
        if (data) {
            if (!isInCluster) {
                setLeft(data);
                setLeftFilter(data);
                let cloneData = cloneDeep(data)
                setCloneLeft(cloneData)
                getListIndividual()
            }
            else {
                if (isInCluster === true) {
                    setLeft(data);
                    setLeftFilter(data);
                    const cloneListRoom = cloneDeep(data)
                    setCloneIndividuals(cloneListRoom)
                    setIndividuals(cloneListRoom);
                }
            }
        }
    }, [data, isInCluster]);

    useEffect(() => {
        if (filter === '')
            setLeft(individuals)
    }, [filter]);

    const handleTransferList = (value, style) => () => {
        if (style === "left") {
            left.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    left.splice(itemIndex, 1)
                }
            })
            individuals.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    individuals.splice(itemIndex, 1)
                }
            })
            if (right.length === 0) {
                right.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < right.length; i++) {
                    if (value.cluster.name === right[i].rooms[0].cluster.name && value.cluster.entity === right[i].rooms[0].cluster.entity
                        && value.cluster.group === right[i].rooms[0].cluster.group) {
                        checkExist = true
                        break
                    }
                    else {
                        checkExist = false
                    }
                }
                if (checkExist) {
                    for (let i = 0; i < right.length; i++) {
                        if (value.cluster.name === right[i].rooms[0].cluster.name && value.cluster.entity === right[i].rooms[0].cluster.entity
                            && value.cluster.group === right[i].rooms[0].cluster.group) {
                            right[i].rooms.push(value)
                        }
                    }
                }
                else {
                    right.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            setLeftFilter(individuals)
            // if (isInCluster === false) {
            //     setLeftFilter(individuals)
            // }
            if (list === false) {
                dispatch(listChange(true))
            }
            else {
                dispatch(listChange(false))
            }
            if (left.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0 && filter === "")
                setCheckedSwitch(true)
            if (individuals.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0)
                setFilter('')
            setLoading(false)
        }
        else {
            setCheckedSwitch(false)
            right.map((item, itemIndex) => {
                if (value.cluster.name === item.name) {
                    const index = item.rooms.findIndex(element => element.id === value.id);
                    if (item.rooms.length > 0)
                        item.rooms.splice(index, 1)
                }
                if (item.rooms.length === 0) {
                    right.splice(itemIndex, 1)
                }
            })
            if (left.length === 0 && filter === "") {
                left.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < left.length; i++) {
                    if (value.cluster.name === left[i].rooms[0].cluster.name && value.cluster.entity === left[i].rooms[0].cluster.entity
                        && value.cluster.group === left[i].rooms[0].cluster.group) {
                        checkExist = true
                        break
                    }
                    else {
                        checkExist = false
                    }
                }
                if (checkExist) {
                    for (let i = 0; i < left.length; i++) {
                        if (value.cluster.name === left[i].rooms[0].cluster.name && value.cluster.entity === left[i].rooms[0].cluster.entity
                            && value.cluster.group === left[i].rooms[0].cluster.group) {
                            for (let j = 0; j < left[i].rooms.length; j++) {
                                if (left[i].rooms[j].id !== value.id) {
                                    left[i].rooms.push(value)
                                    break
                                }
                                else {
                                    break
                                }
                            }
                        }
                    }
                }
                else {
                    left.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            if (individuals.length === 0 && filter === "") {
                individuals.push({
                    name: value.cluster.name,
                    rooms: [value]
                })
            }
            if (individuals.length > 0 && filter !== "") {
                var checkExistIndividual = true
                for (let i = 0; i < individuals.length; i++) {
                    if (value.cluster.name === individuals[i].rooms[0].cluster.name && value.cluster.entity === individuals[i].rooms[0].cluster.entity
                        && value.cluster.group === individuals[i].rooms[0].cluster.group) {
                        checkExistIndividual = true
                        break
                    }
                    else {
                        checkExistIndividual = false
                    }
                }
                if (checkExistIndividual) {
                    for (let i = 0; i < individuals.length; i++) {
                        if (value.cluster.name === individuals[i].rooms[0].cluster.name && value.cluster.entity === individuals[i].rooms[0].cluster.entity
                            && value.cluster.group === individuals[i].rooms[0].cluster.group) {
                            for (let j = 0; j < individuals[i].rooms.length; j++) {
                                if (individuals[i].rooms[j].id !== value.id) {
                                    individuals[i].rooms.push(value)
                                    break
                                }
                                else {
                                    break
                                }
                            }
                        }
                    }
                }
                else {
                    individuals.push({
                        name: value.cluster.name,
                        rooms: [value]
                    })
                }
            }
            if (list === false) {
                dispatch(listChange(true))
            }
            else {
                dispatch(listChange(false))
            }
            if (right.length === 0) {
                setFilter('')
                setLoading(false)
            }
        }
    }

    const handleToggleAllCluster = (value, style) => () => {
        if (list === false) {
            dispatch(listChange(true))
        }
        else {
            dispatch(listChange(false))
        }
        if (style === 'left') {
            if (right.length === 0) {
                individuals.map((item, index) => {
                    if (item.name === value.name) {
                        right.push(item)
                        individuals.splice(index, 1)
                    }
                })
                left.map((item, index) => {
                    if (item.name === value.name)
                        left.splice(index, 1)
                })
                setLeftFilter(individuals)
            }
            else {
                var checkExist = true
                for (let i = 0; i < right.length; i++) {
                    var checkBreak = false
                    for (let j = 0; j < value.rooms.length; j++) {
                        if (value.rooms[j].cluster.name === right[i].rooms[0].cluster.name && value.rooms[j].cluster.entity === right[i].rooms[0].cluster.entity
                            && value.rooms[j].cluster.group === right[i].rooms[0].cluster.group) {
                            checkExist = true
                            checkBreak = true
                            break
                        }
                        else {
                            checkExist = false
                        }
                    }
                    if (checkBreak)
                        break
                }
                if (checkExist) {
                    for (let i = 0; i < right.length; i++) {
                        value.rooms.map(item => {
                            if (item.cluster.name === right[i].rooms[0].cluster.name && item.cluster.entity === right[i].rooms[0].cluster.entity
                                && item.cluster.group === right[i].rooms[0].cluster.group) {
                                right[i].rooms.push(item)
                            }
                        })
                    }
                }
                else {
                    // right.push(value)
                    individuals.map((item, index) => {
                        if (item.name === value.name) {
                            right.push(item)
                            individuals.splice(index, 1)
                        }
                    })
                }
                left.map((item, index) => {
                    if (item.name === value.name)
                        left.splice(index, 1)
                })
                setLeftFilter(individuals)
            }
            if (left.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0 && filter === "")
                setCheckedSwitch(true)
            if (individuals.length > 0 && filter !== "")
                setCheckedSwitch(false)
            if (left.length === 0)
                setFilter('')
        }
        else {
            setCheckedSwitch(false)
            if (left.length === 0) {
                individuals.push(value)
                setLeft(individuals)
                setFilter('')
                // left.push(value)
                right.map((item, index) => {
                    if (item.name === value.name)
                        right.splice(index, 1)
                })
            }
            else {
                var checkExist = true
                for (let i = 0; i < left.length; i++) {
                    var checkBreak = false
                    for (let j = 0; j < value.rooms.length; j++) {
                        if (value.rooms[j].cluster.name === left[i].rooms[0].cluster.name && value.rooms[j].cluster.entity === left[i].rooms[0].cluster.entity
                            && value.rooms[j].cluster.group === left[i].rooms[0].cluster.group) {
                            checkExist = true
                            checkBreak = true
                            break
                        }
                        else {
                            checkExist = false
                        }
                    }
                    if (checkBreak)
                        break
                }
                if (checkExist) {
                    for (let i = 0; i < left.length; i++) {
                        value.rooms.map(item => {
                            if (item.cluster.name === left[i].rooms[0].cluster.name && item.cluster.entity === left[i].rooms[0].cluster.entity
                                && item.cluster.group === left[i].rooms[0].cluster.group) {
                                left[i].rooms.push(item)
                            }
                        })
                    }
                }
                else {
                    left.push(value)
                }
                right.map((item, index) => {
                    if (item.name === value.name)
                        right.splice(index, 1)
                })
            }
        }
    }

    const getText = () => {
        if (!receiver) return '';
        switch (receiver) {
            case RECEIVER_TYPE.ENTITY:
                return translate(`resources.messages.Entity`)
            case RECEIVER_TYPE.GROUP:
                return translate(`resources.messages.Group`)
            case RECEIVER_TYPE.CLUSTER:
                return translate(`resources.messages.Cluster`)
            case RECEIVER_TYPE.INDIVIDUALS:
                return translate(`resources.messages.Room`)
            case RECEIVER_TYPE.USER:
                return translate(`resources.messages.User`)
        }
    }

    const customList = (items, style, filter) => {
        return (
            <List className={classes.list} component="div" disablePadding >
                {style === "left" &&
                    <Box padding="8px">
                        <Box width='100%' display='flex' className={classes.borderSearch} >
                            < img src={icSearch} className={classes.iconSearch} width={15} height={15} style={{ margin: 'auto 2px auto 5px' }}></img>
                            <InputBase
                                fullWidth={true}
                                placeholder={translate(`resources.alarm.search`) + getText().toLowerCase()}
                                inputProps={{
                                    'aria-label': 'search',
                                    className: classes.textSearch
                                }}
                                onChange={onChangeFilter}
                                value={filter}
                                style={{ width: '180px' }}
                            />
                        </Box>
                    </Box>
                }
                {style === "left" && <Divider />}
                {
                    items.map((value, idx) => {
                        return (
                            < Box style={{ marginLeft: 10 }} key={idx}>
                                <Typography onClick={handleToggleAllCluster(value, style)}>{value.name}</Typography>
                                {value.rooms.map((element, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <Box display="flex" alignItems="center" key={element.id} onClick={handleTransferList(element, style)}>
                                                <Checkbox
                                                    checked={style === 'right'}
                                                    color='primary'
                                                />
                                                <Typography className={classes.clusterText} >{element.name}</Typography>
                                            </Box>
                                            <Divider />
                                        </React.Fragment>
                                    )
                                })}
                            </Box>
                        )
                    })
                }
            </List >
        )
    };

    const onEnter = () => {
        setSelectedTone(null);
    }

    return (
        <Dialog open={open} scroll='paper' onClose={handleClose} classes={{ paper: classes.dialogPaper }} fullWidth={true} onEnter={onEnter} disableEnforceFocus disableBackdropClick>
            <Box mx={5} mt={3} ref={node => dialogContent = node}>
                <Box display='flex' justifyContent='flex-end' alignItems='center'>
                    <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
                    <CloseButton onClick={handleClose} />
                </Box>
                <Typography className={classes.Title}>{translate(`resources.alarm.sendalarm`)}</Typography>
            </Box>
            {
                loadingDialog ? <Box style={{ height: '74vh' }}><Loading /></Box> : (
                    <div>
                        <DialogContent style={{ padding: '8px 40px' }} >
                            <Collapse in={errorMsg.length > 0}>
                                <Alert severity="error">{errorMsg}</Alert>
                            </Collapse>
                            <Box display="flex" mx={2.5}>
                                <Box flex="1" display="flex" alignItems="flex-end">
                                    <Typography className={classes.addRecipientsText}>{translate(`resources.messages.addrecipients`)}</Typography>
                                    <Box px={1} className={classes.switchAddAll}>
                                        <Typography className={classes.switchText}>
                                            {translate(`resources.messages.addallrecipients`) + getText()}
                                        </Typography>
                                        <GreenSwitch size='small' style={{ color: 'white' }} checked={checkedSwitch} onChange={handleToggleAll(left)} />
                                    </Box>
                                </Box>
                                <Box style={{ width: 20 }} />
                                <Box flex="1" display="flex" alignItems="flex-end">
                                    <Typography className={classes.addRecipientsText}>{translate(`resources.messages.selectrecipients`)}</Typography>
                                </Box>
                            </Box>
                            {receiver === 'Individuals' ? (
                                <Box display="flex" mx={2.5} mt={1}>
                                    <Box flex="1">
                                        {customList(left, "left", filter)}
                                    </Box>
                                    <Box style={{ width: 20 }} />
                                    {
                                        right.length > 0 ?
                                            <Box flex="1">{customList(right, "right")}</Box> :
                                            <Box flex="1">
                                                <List className={classes.list} component="div" disablePadding >
                                                    <Typography style={{ textAlign: 'center', paddingTop: "120px" }} className={classes.NoRecipientsSelected}>{translate(`resources.alarm.Nodata`)}</Typography>
                                                </List>
                                            </Box>
                                    }
                                </Box>
                            ) : (
                                    <Box display="flex" mx={2.5} mt={1}>
                                        <TransferList
                                            setLeft={setLeft}
                                            left={left}
                                            setRight={setRight}
                                            right={right}
                                            receiver={receiver}
                                            checkedSwitch={checkedSwitch}
                                            setCheckedSwitch={setCheckedSwitch}
                                            start={start}
                                            oldLeft={cloneLeft}
                                        />
                                    </Box>
                                )
                            }

                            <Box mt={4} mx={2.5}>
                                <SelectBox label={translate(`pos.messages.template`)} alignItems="center" open={openTemplate} value={template} handleClick={handleClickOpenTemplate}>
                                    <SelectBoxTemplateList list={listTemplates} onChangeTemplate={onChangeTemplate} />
                                </SelectBox>
                            </Box>
                            <Box mt={4} mx={2.5}>
                                <Field
                                    id="filled-basic"
                                    label={translate(`pos.messages.subject`)}
                                    value={textValue.subject}
                                    onChange={textOnChange('subject')}
                                    style={{ width: 525 }}
                                    endDom={<CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.messages.subject`)}
                                        content={translate(`pos.messages.constentSubject`)}
                                        icon={<b>?</b>}
                                    />}
                                />
                            </Box>
                            <SelectBoxTone
                                selectedTone={selectedTone}
                                setSelectedTone={setSelectedTone}
                            />
                            <Box mt={4} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio} >{translate(`pos.messages.schedule`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.messages.schedule`)}
                                                content={translate(`pos.alarm.constentSchedule`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valueScheduleRadio} onChange={handleRadioScheduleChange}>
                                        <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Immediately`)} />
                                        <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.Other`)} style={{ marginLeft: '63px' }} />
                                        <FormControlLabel value={2} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.ScheduleTemplate`)} style={{ marginLeft: '70px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <SelectBoxInterval
                                open={valueScheduleRadio === 1}
                                recurrence={selectedRecurrence}
                                onSelect={onChangeRecurrence}
                            />
                            <DateTimePicker
                                open={valueScheduleRadio === 1}
                                date={dateSchedule}
                                setDate={setDateSchedule}
                                style="alarm"
                                minDate={new Date()}
                                title={translate(`resources.reviews.fields.date`)}
                            />
                            <SelectBoxScheduleTemplate
                                open={valueScheduleRadio === 2}
                                scheduleTemplate={selectedScheduleTemplate}
                                onSelect={onChangeScheduleTemplate}
                            />
                            <Divider className={classes.divider} />
                            <Box mt={2.5} mx={2.5}>
                                <FormControl component="fieldset">
                                    <Grid container spacing={1} alignItems="center" >
                                        <Grid item>
                                            <Typography className={classes.titleRadio} >{translate(`pos.messages.expiration`)}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <CustomMessagePoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.messages.expiration`)}
                                                content={translate(`pos.alarm.constentExpiration`)}
                                                icon={<b>?</b>}
                                            />
                                        </Grid>
                                    </Grid>
                                    <RadioGroup row aria-label="position" name="position" value={valueExpirationRadio} onChange={handleRadioExpirationChange}>
                                        <FormControlLabel value={0} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.none`)} />
                                        <FormControlLabel value={1} control={<Radio color="primary" icon={<RadioButtonUncheckedIcon style={{ fontSize: '24px' }} />} checkedIcon={<RadioButtonCheckedIcon style={{ fontSize: '24px' }} />} />} classes={{ label: classes.titleRadio }} label={translate(`resources.messages.daytime`)} style={{ marginLeft: '100px' }} />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <DateTimePicker
                                minDate={new Date()}
                                title={translate(`resources.reviews.fields.date`)}
                                open={valueExpirationRadio === 1}
                                date={dateExpiration}
                                setDate={setDateExpiration}
                                style='alarm'
                            />
                            <Divider className={classes.divider} />
                            <Box mt={4.9} mx={2.5}>
                                <CustomTextField
                                    onBlur={() => {
                                        validate('content', textValue.content)
                                    }}
                                    className={classes.inputMulti}
                                    id="textfield-message"
                                    multiline
                                    rows={4}
                                    value={textValue.content}
                                    onChange={textOnChange('content')}
                                    placeholder={`${translate(`pos.messages.placeholder`)} *`}
                                    error={error.message !== "" && error.isError}
                                    helperText={error.message}
                                    isDyslexieEnable={isDyslexieEnable}
                                    fontSize={fontSize}
                                    setFontSize={setFontSize}
                                    endDom={
                                        <Box>
                                            <Box className={classes.inputPopper}>
                                                <CustomPoper
                                                    open={openPoper}
                                                    anchorEl={anchorEl}
                                                    handleClick={handleClickOpenPoper}
                                                    handleClose={handleClosePoper}
                                                    title={translate(`pos.messages.constent`)}
                                                    content={translate(`pos.messages.constentContent`)}
                                                    icon={<b>?</b>}
                                                />
                                            </Box>
                                        </Box>
                                    }
                                />
                            </Box>
                            <Box mt={3} mx={2.5} display='flex' alignItems='center'>
                                <Grid
                                    container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="flex-start">
                                    <Grid item style={{ marginLeft: '360px' }}>
                                        <Box display='flex' borderRadius={4} bgcolor='background.paper' py={0.4} pr={1} pl={2} alignItems='center'>
                                            <Box flexGrow={1}>
                                                <Typography className={classes.TitileDyslexieFont} style={{ marginRight: 10 }}>{translate(`pos.messages.dyslexieFont`).toUpperCase()}</Typography>
                                            </Box>
                                            <GreenSwitch checked={isDyslexieEnable} onChange={() => setDyslexieEnable(!isDyslexieEnable)}
                                                size='small' style={{ color: 'white' }}></GreenSwitch>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </DialogContent>
                    </div>
                )
            }
            {!loadingDialog &&
                <DialogActions className={classes.dialogActions}>
                    <TextButton mr={2} style={{ marginTop: "1em" }} onClick={handleClose}/>
                       
                    <Button onClick={handleSaveDraftAlarm} className={classes.saveDraft} color="primary">
                        {loadingDraft ? (
                            <CircularProgress
                                size={25}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            <Typography className={classes.btnSave}>  {translate('pos.messages.save')}</Typography>
                        }
                    </Button>
                    <Button
                        disabled={disableSendButton()}
                        variant="contained"
                        className={classes.send}
                        size="large"
                        color="primary"
                        onClick={handleSendAlarm}
                    >
                        {loading ? (
                            <CircularProgress
                                size={25}
                                thickness={2}
                                color='inherit'
                            />
                        ) :
                            <Typography className={classes.btnSend}>{translate('pos.alarm.send')}</Typography>
                        }
                    </Button>
                </DialogActions>
            }

        </Dialog>
    )
}

DialogAlarmSendMessage.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DialogAlarmSendMessage;
